<template>
  <div class="interactive" :style="{ height: height + 'px' }">
    <div :style="{ height: ( height - 20 ) + 'px' }" class="content">
      <div class="rolling">
        <li>
          <div class="img fl"><img src="../../../assets/portrait.png" width="40" height="40" alt=""></div>
          <div class="Txt fr">
            <div class="name">
              <span class="fl">彭小呆</span>
            </div>
            <div class="p">感谢老师的入微指点，层次清晰，讲解全面感谢老师的入微指点，层次清晰，讲解全面感谢
              老师的入微指点，层次清晰，讲解全面感谢老师的入微指点，层次清晰，讲解全面</div>
          </div>
        </li>
        <li>
          <div class="img fl"><img src="../../../assets/portrait.png" width="40" height="40" alt=""></div>
          <div class="Txt fr">
            <div class="name">
              <span class="fl">彭小呆</span>
            </div>
            <div class="p">感谢老师的入微指点，层次清晰，讲解全面</div>
          </div>
        </li>
        <li>
          <div class="img fl"><img src="../../../assets/portrait.png" width="40" height="40" alt=""></div>
          <div class="Txt fr">
            <div class="name">
              <span class="fl">彭小呆</span>
            </div>
            <div class="p">感谢老师的入微指点，层次清晰，讲解全面</div>
          </div>
        </li>
      </div>
      <el-input
        type="textarea"
        class="textarea"
        placeholder="请输入内容"
        v-model="textarea">
      </el-input>
      <div class="sure fr">确定</div>
    </div>
  </div>
</template>

<script>
  export default {
    props: {
      height: {
        type: Number,
        default: 3.5
      }
    },
    data () {
      return {
        textarea: ''
      }
    },
    methods: {
      answer () {
        this.$emit('changIndex', 1)
      }
    }
  }
</script>

<style type="text/scss" lang="scss">
  .interactive {
    width: 360px;
    margin: 0 auto;
    overflow: hidden;

    .content {
      margin: 20px auto 0;

      .textarea {
        height: 20%;
        margin-top: 10%;

        textarea {
          height: 100%;

          &:focus {
            border: 1px solid #ff827b;
          }
        }
      }

      .rolling {
        height: 60%;
        overflow-x: hidden;
        overflow-y: scroll;

        &::-webkit-scrollbar {
          display: none;
        }

        li {
          overflow: hidden;
          margin-top: 15px;
          border-bottom: 1px solid #ebebeb;
          padding-bottom: 10px;

          &:first-child {
            margin: 0;
          }

          .img {
            width: 40px;
            height: 40px;
          }

          .Txt {
            width: 310px;

            .name {
              line-height: 25px;
              margin: 5px auto 0;
              width: 100%;
              height: 25px;
              overflow: hidden;

              .fl {
                font-size: 16px;
              }

              .fr {
                font-size: 14px;
                color: #b3b3b3;
              }
            }

            .p {
              font-size: 14px;
              margin: 5px auto 0;
              line-height: 30px;
            }
          }
        }
      }

      .sure {
        width: 110px;
        height: 40px;
        background-color: #ff8484;
        text-align: center;
        color: #fff;
        line-height: 40px;
        border-radius: 20px;
        cursor: pointer;
        margin: 20px 0 0 0;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/liveLayer/interactive/interactive.vue